import React, { useState } from 'react';
import { Layout, Menu, ConfigProvider, theme } from 'antd';
import {
  BookOutlined,
  CloudDownloadOutlined,
  FileTextOutlined,
  FunctionOutlined,
  BarChartOutlined,
  MessageOutlined
} from '@ant-design/icons';
import zhCN from 'antd/locale/zh_CN';

// 引入页面组件
import HelpCenterModule from './pages/HelpCenterModule';
import DataExportModule from './pages/DataExportModule';
import DocumentManagementModule from './pages/DocumentManagementModule';
import AlgorithmLibraryModule from './pages/AlgorithmLibraryModule';
import CarbonEstimationModule from './pages/CarbonEstimationModule';
import FeedbackSystemModule from './pages/FeedbackSystemModule';

const { Header, Content, Sider, Footer } = Layout;

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [currentKey, setCurrentKey] = useState('estimation'); // 默认显示碳储量估算
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const items = [
    { key: 'help', icon: <BookOutlined />, label: '帮助中心', component: <HelpCenterModule /> },
    { key: 'export', icon: <CloudDownloadOutlined />, label: '数据导出', component: <DataExportModule /> },
    { key: 'docs', icon: <FileTextOutlined />, label: '文档管理', component: <DocumentManagementModule /> },
    { key: 'algo', icon: <FunctionOutlined />, label: '算法库', component: <AlgorithmLibraryModule /> },
    { key: 'estimation', icon: <BarChartOutlined />, label: '碳储量估算', component: <CarbonEstimationModule /> },
    { key: 'feedback', icon: <MessageOutlined />, label: '反馈系统', component: <FeedbackSystemModule /> },
  ];

  const renderContent = () => {
    const activeItem = items.find(item => item.key === currentKey);
    return activeItem ? activeItem.component : <div>Loading...</div>;
  };

  return (
    <ConfigProvider locale={zhCN}>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
          <div style={{ height: 32, margin: 16, background: 'rgba(255, 255, 255, 0.2)', textAlign: 'center', color: '#fff', lineHeight: '32px', fontWeight: 'bold', overflow: 'hidden' }}>
            Carbon-Sys
          </div>
          <Menu 
            theme="dark" 
            defaultSelectedKeys={['estimation']} 
            mode="inline" 
            items={items.map(({ key, icon, label }) => ({ key, icon, label }))} 
            onClick={(e) => setCurrentKey(e.key)}
          />
        </Sider>
        <Layout>
          <Header style={{ padding: 0, background: colorBgContainer }}>
            <h2 style={{ margin: '0 16px' }}>遥感反演碳储量结果可视化与导出系统</h2>
          </Header>
          <Content style={{ margin: '16px' }}>
            <div
              style={{
                padding: 24,
                minHeight: 360,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
                height: '100%',
                overflow: 'auto'
              }}
            >
              {renderContent()}
            </div>
          </Content>
          <Footer style={{ textAlign: 'center' }}>
            Carbon Sensing System ©2025 Created by React & Ant Design
          </Footer>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default App;